module.exports = __webpack_public_path__ + "img/c2.209ba11b.jpg";